import { render, staticRenderFns } from "./waterLevelFour.vue?vue&type=template&id=5c6d8857&scoped=true&"
import script from "./waterLevelFour.vue?vue&type=script&lang=js&"
export * from "./waterLevelFour.vue?vue&type=script&lang=js&"
import style0 from "./waterLevelFour.vue?vue&type=style&index=0&id=5c6d8857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d8857",
  null
  
)

export default component.exports